import React from 'react'
import Price from './price'
import { sortByAge } from '../helpers/logic'

function PricingBlock({ price, member, isDynamicPricing }) {
  const renderPricing = () => {
    return sortByAge(price).map((value, index) => {
      return (
        <Price
          key={index}
          price={value}
          member={member}
          isDynamicPricing={isDynamicPricing}
        />
      )
    })
  }
  return <React.Fragment>{renderPricing()}</React.Fragment>
}

export default PricingBlock
